module.exports = __webpack_public_path__ + "img/mainDec.c2d08b2.webp";